import React, { useContext } from "react";
import PropTypes from "prop-types";

const AuthContext = React.createContext({
  id: 0,
  roles: [],
  loggedIn: false,
});

const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  // this component houses authoritative auth state
  // whatever logic that determines a valid auth state should live here
  const auth = {
    id: 0,
    roles: [],
    loggedIn: false,
  };

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export { AuthProvider, useAuth };
